import { useFormik } from 'formik';
import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import { login } from '../_redux/authCrud';
import * as auth from '../_redux/authRedux';

const initialValues = {
  email: '',
  password: '',
};

function Login(props) {
  const { intl } = props;
  const emailLabel = intl.formatMessage({ id: 'AUTH.LOGIN.EMAIL' });
  const passwordLabel = intl.formatMessage({ id: 'AUTH.LOGIN.PASSWORD' });
  const emailFormatError = intl.formatMessage({
    id: 'GENERAL.VALIDATION.INVALID',
  });
  const emailMinLengthError = intl
    .formatMessage({ id: 'GENERAL.VALIDATION.MIN_LENGTH' })
    .replace('#value#', '7');
  const emailMaxLengthError = intl
    .formatMessage({ id: 'GENERAL.VALIDATION.MAX_LENGTH' })
    .replace('#value#', '50');
  const passMinLengthError = intl
    .formatMessage({ id: 'GENERAL.VALIDATION.MIN_LENGTH' })
    .replace('#value#', '3');
  const passMaxLengthError = intl
    .formatMessage({ id: 'GENERAL.VALIDATION.MAX_LENGTH' })
    .replace('#value#', '20');
  const [loading, setLoading] = useState(false);
  const [passTryCount, setPassTryCount] = useState(0);
  const [captcha, setCaptcha] = useState('');
  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email(emailFormatError)
      .min(7, emailMinLengthError)
      .max(50, emailMaxLengthError)
      .required(
        intl.formatMessage({
          id: 'GENERAL.VALIDATION.REQUIRED',
        })
      ),
    password: Yup.string()
      .min(3, passMinLengthError)
      .max(20, passMaxLengthError)
      .required(
        intl.formatMessage({
          id: 'GENERAL.VALIDATION.REQUIRED',
        })
      ),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return 'is-invalid';
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return 'is-valid';
    }

    return '';
  };
  const onCaptchaChange = (value) => {
    console.log('Captcha value:', value);
    setCaptcha(value);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      //console.log('Password:', values.email, values.password, captcha); // for find the issue
      login(values.email, values.password, captcha)
        /* .then(({ data: { accessToken } }) => { */
        .then((response) => {
          //console.log('Login response', response.data);
          switch (response.data.type) {
            case 'SUCCESS':
            case 'SUCCESS_WITH_INFO':
              disableLoading();
              props.login(response.data.data.token);
              break;
            case 'SUCCESS_WITH_WARNING':
              disableLoading();
              props.login(response.data.data.token);
              // return <Redirect to='/user-profile/change-password' />; // ? ajillahgui bgaa
              break;
            default:
              console.log('Login error', response.data.msg, response.data.data);
              setPassTryCount(response.data.data);
              disableLoading();
              setSubmitting(false);
              setStatus({
                type: 'error',
                msg: response.data.msg.desc,
              });
              // setCaptcha('');
              if (passTryCount > 3) window.grecaptcha.reset();
          }
        })
        .catch((error) => {
          console.log('Login error', error[0]);
          disableLoading();
          setSubmitting(false);
          setStatus({
            type: 'error',
            msg: intl.formatMessage({
              id: 'AUTH.VALIDATION.INVALID_LOGIN',
            }),
          });
          setCaptcha('');
        });
    },
  });

  const location = useLocation();
  if (location && location.state) {
    formik.status.type = 'success';
    formik.status.msg = location.state.msg;
  }

  return (
    <div className='login-form login-signin' id='kt_login_signin_form'>
      {/* begin::Head */}
      <div className='text-center mb-10 mb-lg-20'>
        <h3 className='font-size-h1'>
          <FormattedMessage id='AUTH.LOGIN.TITLE' />
        </h3>
        <p className='text-muted font-weight-bold'>
          <FormattedMessage id='AUTH.LOGIN.SUBTITLE' />
        </p>
      </div>
      {/* end::Head */}

      {/*begin::Form*/}
      <form
        onSubmit={formik.handleSubmit}
        className='form fv-plugins-bootstrap fv-plugins-framework'
      >
        {formik.status && formik.status.type === 'error' && (
          <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
            <div className='alert-text font-weight-bold'>
              {formik.status.msg}
            </div>
          </div>
        )}

        {formik.status && formik.status.type === 'success' && (
          <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
            <div className='alert-text font-weight-bold'>
              {formik.status.msg}
            </div>
          </div>
        )}

        <div className='form-group fv-plugins-icon-container'>
          <input
            placeholder={emailLabel}
            type='email'
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              'email'
            )}`}
            name='email'
            {...formik.getFieldProps('email')}
          />
          {formik.touched.email && formik.errors.email ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{formik.errors.email}</div>
            </div>
          ) : null}
        </div>
        <div className='form-group fv-plugins-icon-container'>
          <input
            placeholder={passwordLabel}
            type='password'
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              'password'
            )}`}
            name='password'
            {...formik.getFieldProps('password')}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{formik.errors.password}</div>
            </div>
          ) : null}
        </div>
        <div className='form-group'>
          <label className='checkbox'>
            <input
              type='checkbox'
              name='rememberMe'
              className='m-1'
              {...formik.getFieldProps('rememberMe')}
            />
          </label>
          {formik.touched.acceptTerms && formik.errors.acceptTerms ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{formik.errors.acceptTerms}</div>
            </div>
          ) : null}
        </div>
        {passTryCount > 3 ? (
          <div className='form-group'>
            <ReCAPTCHA
              id='recaptcha'
              sitekey='6LelSq0eAAAAAHnwctgzPHi4o_r-ye7nuYKZn9wz'
              onChange={onCaptchaChange}
              /* ref={(r) => setCaptcha(r)} */
            />
          </div>
        ) : (
          <></>
        )}
        <div className='form-group d-flex flex-wrap justify-content-between align-items-center'>
          <Link
            to='/auth/forgot-password'
            className='text-dark-50 text-hover-success my-3 mr-2'
            id='kt_login_forgot'
          >
            <FormattedMessage id='AUTH.GENERAL.FORGOT_BUTTON' />
          </Link>
          <button
            id='kt_login_signin_submit'
            type='submit'
            disabled={formik.isSubmitting}
            className={`btn btn-info font-weight-bold px-9 py-4 my-3`}
          >
            <span>
              <FormattedMessage id='AUTH.LOGIN.BUTTON' />
            </span>
            {loading && <span className='ml-3 spinner spinner-white'></span>}
          </button>
        </div>
      </form>
      {/*end::Form*/}
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
